import Container from "./Container";
import styles from "./Footer.module.css";

const Icon = ({ path, label }) => (
  <a href="/#" aria-label={label} className={styles.social}>
    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
      <path d={path} />
    </svg>
  </a>
);

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <Container>
        <div className={styles.grid}>
          <div className={styles.brandCol}>
            <div className={styles.brand}>
              <span className={styles.dot} aria-hidden="true" /> Urban Services
            </div>
            <p className={styles.blurb}>
              Trusted home services, delivered with care. Verified pros for cleaning,
              cooking, plumbing, electrical, and househelp — right at your doorstep.
            </p>
          </div>
          <div>
            <h6 className={styles.head}>Cities</h6>
            <ul className={styles.list}>
              <li>Goregaon</li>
              <li>Mahim</li>
              <li>Prabhadevi</li>
              <li>Matunga</li>
            </ul>
          </div>
          <div>
            <h6 className={styles.head}>Services</h6>
            <ul className={styles.list}>
              <li><a href="/#services">Cleaning</a></li>
              <li><a href="/#services">Cooking</a></li>
              <li><a href="/#services">Plumbing</a></li>
              <li><a href="/#services">Electrical</a></li>
              <li><a href="/#services">Househelp</a></li>
            </ul>
          </div>
          <div>
            <h6 className={styles.head}>Contact</h6>
            <ul className={styles.list}>
              <li>Mumbai — 400001</li>
              <li><a href="tel:9876543210">9876543210</a></li>
              <li><a href="mailto:support@urbanservices.com">support@urbanservices.com</a></li>
            </ul>
          </div>
        </div>
        <div className={styles.bottom}>
          <p className={styles.copy}>© 2026 Urban Services. All rights reserved.</p>
          <div className={styles.socials}>
            <Icon label="Facebook" path="M13 22v-9h3l.5-3.5H13V7.2c0-1 .3-1.7 1.7-1.7H17V2.3C16.4 2.2 15.3 2 14.2 2 11.8 2 10 3.5 10 6.3v3.2H7V13h3v9h3z" />
            <Icon label="Twitter" path="M22 5.9c-.7.3-1.5.6-2.3.7.8-.5 1.5-1.3 1.8-2.3-.8.5-1.7.8-2.6 1a4 4 0 0 0-6.9 3.7A11.3 11.3 0 0 1 3.8 4.7a4 4 0 0 0 1.2 5.4c-.6 0-1.2-.2-1.7-.5a4 4 0 0 0 3.2 4c-.5.1-1 .2-1.6.1a4 4 0 0 0 3.7 2.8A8 8 0 0 1 2 18.6a11.3 11.3 0 0 0 6.1 1.8c7.4 0 11.4-6.1 11.4-11.4v-.5c.8-.6 1.5-1.3 2-2.1z" />
            <Icon label="LinkedIn" path="M6.9 8H4V22h2.9V8zM5.4 3.5A1.7 1.7 0 1 0 5.4 7a1.7 1.7 0 0 0 0-3.5zM22 22h-2.9v-6.9c0-1.6 0-3.7-2.3-3.7s-2.6 1.8-2.6 3.6V22H11V8h2.8v1.9h.1c.4-.7 1.4-1.6 3-1.6 3.2 0 3.8 2.1 3.8 4.9V22z" />
          </div>
        </div>
      </Container>
    </footer>
  );
}
